import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ellipseFieldHost]'
})
export class FieldHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
